import { render, staticRenderFns } from "./PaymentOrderGeneralSideForm.vue?vue&type=template&id=f161f5f6&scoped=true&"
import script from "./PaymentOrderGeneralSideForm.vue?vue&type=script&lang=js&"
export * from "./PaymentOrderGeneralSideForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f161f5f6",
  null
  
)

export default component.exports